/*!
 * TOAST UI Editor : Code Syntax Highlight Plugin
 * @version 1.0.0 | Wed Mar 18 2020
 * @author NHN FE Development Lab <dl_javascript@nhn.com>
 * @license MIT
 */
module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 1);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = require("highlight.js/lib/highlight");

/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, "default", function() { return /* binding */ codeSyntaxHighlightPlugin; });

// EXTERNAL MODULE: external "highlight.js/lib/highlight"
var highlight_ = __webpack_require__(0);
var highlight_default = /*#__PURE__*/__webpack_require__.n(highlight_);

// CONCATENATED MODULE: ./src/js/helper.js
/**
 * @fileoverview Implements helper for plugin
 * @author NHN FE Development Lab <dl_javascript@nhn.com>
 */

/**
 * Register highlight.js to instance of Editor or Viewer
 * @param {Editor|Viewer} editor - instance of Editor or Viewer
 * @param {Object} [hljs] - object of highlight.js
 */
function registerCodeBlockReplacer(editor, hljs) {
  var codeBlockManager = Object.getPrototypeOf(editor).constructor.codeBlockManager;
  var languages = hljs.listLanguages();
  editor.setCodeBlockLanguages(languages);
  languages.forEach(function (type) {
    var convertor = function convertor(codeText) {
      return hljs.highlight(type, codeText).value;
    };

    var aliases = hljs.getLanguage(type).aliases || [];
    var langTypes = [type].concat(aliases);
    langTypes.forEach(function (lang) {
      codeBlockManager.setReplacer(lang, convertor);
    });
  });
}
// CONCATENATED MODULE: ./src/js/index.js
/**
 * @fileoverview Implements code syntax highlight plugin
 * @author NHN FE Development Lab <dl_javascript@nhn.com>
 */


/**
 * Code syntax highlight plugin to import selected languages
 * @param {Editor|Viewer} editor - instance of Editor or Viewer
 * @param {Object} [options] - options for plugin
 * @param {Object} [options.hljs] - object of highlight.js
 */

function codeSyntaxHighlightPlugin(editor, options) {
  if (options === void 0) {
    options = {};
  }

  var editorHljs = options.hljs || highlight_default.a;

  if (editorHljs) {
    registerCodeBlockReplacer(editor, editorHljs);
  }
}

/***/ })
/******/ ])["default"];